// IST (Asia/Kolkata) time helpers — never rely on the browser timezone.

// Returns current wall-clock time in IST as a Date-like via component parts.
export function nowIstParts() {
  const fmt = new Intl.DateTimeFormat("en-CA", {
    timeZone: "Asia/Kolkata",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  });
  const parts = fmt.formatToParts(new Date());
  const map = {};
  for (const p of parts) map[p.type] = p.value;
  return map;
}

// YYYY-MM-DD in IST
export function istTodayStr() {
  const m = nowIstParts();
  return `${m.year}-${m.month}-${m.day}`;
}

// milliseconds remaining until next 00:00 IST
export function msUntilNextIstMidnight() {
  const m = nowIstParts();
  const h = parseInt(m.hour === "24" ? "0" : m.hour, 10);
  const min = parseInt(m.minute, 10);
  const s = parseInt(m.second, 10);
  const elapsed = (h * 3600 + min * 60 + s) * 1000;
  const dayMs = 24 * 3600 * 1000;
  return dayMs - elapsed;
}

export function formatCountdown(ms) {
  if (ms < 0) ms = 0;
  const totalSec = Math.floor(ms / 1000);
  const hrs = Math.floor(totalSec / 3600);
  const mins = Math.floor((totalSec % 3600) / 60);
  const secs = totalSec % 60;
  return { hrs, mins, secs };
}

export function prettyDate(dateStr) {
  // dateStr = YYYY-MM-DD
  const [y, mo, d] = dateStr.split("-").map(Number);
  const dt = new Date(Date.UTC(y, mo - 1, d));
  return dt.toLocaleDateString("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
    timeZone: "UTC",
  });
}
